export const COLORS = ["#ff4747", "#ffa500", "#00C49F", "#0088FE", "#6d96f7" ];
export const bg = '#c0c0c080';